jQuery(document).ready(function () {

	const directoryListingsForm = document.querySelector('.js-directory-listings-form');

	if (!directoryListingsForm) {
		return;
	}

	submitFormOnCheckboxChange(directoryListingsForm);	
	handleFilterToggles();
	handleFilterSidebarToggle();
});

function handleFilterToggles() {
	jQuery('button.directory-results__sidebar-filter-heading').each(function () {
		jQuery(this).on('click', function (e) {
			e.preventDefault();
			let $container = jQuery(this).closest('.directory-results__sidebar-filter');
			$container.find('.directory-results__sidebar-filter-choices').toggleClass('open');
		});
	});
}

function handleFilterSidebarToggle() {
	jQuery('.js-directory-filter-toggle').on('click', function () {
		jQuery('.directory-results__sidebar-filters').toggleClass('open');
		if (jQuery('.directory-results__sidebar-filters').hasClass('open')) {
			document.body.style.overflow = 'hidden';
			document.body.classList.add('directory-sidebar-open');
		} else {
			closeSidebarFilters();
		}
	});
	jQuery(document).on('click', function (e) {
		if (!jQuery(e.target).closest('.directory-results__sidebar-filters, .js-directory-filter-toggle').length) {
			closeSidebarFilters();
		}
	});
	jQuery(document).on('keydown', function (e) {
		if (e.key === 'Escape') {
			closeSidebarFilters()
		}
	});
}

function closeSidebarFilters() {
	jQuery('.directory-results__sidebar-filters').removeClass('open');
	document.body.style.overflow = '';
	document.body.classList.remove('directory-sidebar-open');
}

function submitFormOnCheckboxChange(form) {
	const checkboxFields = form.querySelectorAll('input[type="checkbox"]');
	checkboxFields.forEach(field => {
		field.addEventListener('change', function () {
			if(isTabletPlus()) {
				form.submit();
			}
		});
	});
}

function isTabletPlus() {
	return window.innerWidth >= 782;
}
